module.exports = __webpack_public_path__ + "img/4.e233860e.png";